import { render, staticRenderFns } from "./sdpLogsComponent.vue?vue&type=template&id=c5afbb54&class=full-height&"
import script from "./sdpLogsComponent.vue?vue&type=script&lang=js&"
export * from "./sdpLogsComponent.vue?vue&type=script&lang=js&"
import style0 from "./sdpLogsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5afbb54')) {
      api.createRecord('c5afbb54', component.options)
    } else {
      api.reload('c5afbb54', component.options)
    }
    module.hot.accept("./sdpLogsComponent.vue?vue&type=template&id=c5afbb54&class=full-height&", function () {
      api.rerender('c5afbb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/socketInfo/components/sdpLogsComponent.vue"
export default component.exports